export default "__VITE_ASSET__Dvo6MZBu__"